module.exports = __webpack_public_path__ + "img/accompagnements.085f948c.png";